import { render, staticRenderFns } from "./catalog-item-large-mobile-form.vue?vue&type=template&id=0be532a4"
import script from "./catalog-item-large-mobile-form.vue?vue&type=script&lang=js"
export * from "./catalog-item-large-mobile-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CatalogItemPrice: require('/var/www/components/catalog/catalog-item/catalog-item-components/catalog-item-price.vue').default,CatalogItemImg: require('/var/www/components/catalog/catalog-item/catalog-item-components/catalog-item-img.vue').default,CatalogItemTechList: require('/var/www/components/catalog/catalog-item/catalog-item-components/catalog-item-tech-list.vue').default})
